import { render } from "./StoreItems.vue?vue&type=template&id=6d16e852"
import script from "./StoreItems.vue?vue&type=script&lang=js"
export * from "./StoreItems.vue?vue&type=script&lang=js"

import "./StoreItems.vue?vue&type=style&index=0&id=6d16e852&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__